module.exports = __webpack_public_path__ + "static/media/take-picture.35cd61fd.svg";